module.exports = __webpack_public_path__ + "img/jpeg.e075e93f.png";